'use client';

import { CatCard } from 'components/blocks-components';
import styles from '../../not-found.module.scss';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import cx from 'classnames';
import { ReactNode } from 'react';

export default function FaqCard({ isOnboardedUser, faqUrl, oldFaqUrl }) {
  const t = useTranslations();
  const faqLinkHref = isOnboardedUser ? faqUrl : oldFaqUrl;
  const faqLinkTarget = isOnboardedUser ? '_blank' : '_self';

  const LinkComponent = isOnboardedUser
    ? Link
    : (props: { target: string; href: string; children: ReactNode }) => (
        <a target={props.target} href={props.href}>
          {props.children}
        </a>
      );

  return (
    <CatCard
      className={cx(
        'd-flex flex-column',
        styles['not-found__container__cards-section__card']
      )}
    >
      <LinkComponent href={faqLinkHref} target={faqLinkTarget}>
        <div
          className={cx(
            'd-flex flex-column',
            styles['not-found__container__cards-section__card-content']
          )}
        >
          <p className="cat-u-theme-typography-title mb-0">
            {t('HELP_CTR_MNU_FAQ')}
          </p>
          <p className="cat-u-theme-typography-body u-color--ExtraDarkGray mb-0 w-100">
            {t('FAQS_DETAILS')}
          </p>
        </div>
      </LinkComponent>
    </CatCard>
  );
}
